import { Button, Form, Input, Rate } from "antd";
import { LazySvgIcon } from "components/UI/icon";
import Logo from "./Logo";
import { useEffect, useMemo, useRef, useState } from "react";
import { useCreateRating } from "queries/ratings";
import { useAntdMessage } from "hooks/useAntdMessage";
import { debounce } from "lodash-es";
const { TextArea } = Input;

const FormRating = ({
  data = null,
  conversationKey,
  refetch,
  isLoading,
  setRatingPage,
}) => {
  const { message } = useAntdMessage();
  const [form] = Form.useForm();
  const createRating = useCreateRating();
  const [loading, setLoading] = useState(false);

  const submitHandler = (values) => {
    const payload = {
      key: conversationKey,
      rating_value: values.rating_value,
      message: values.message || "",
    };
    if (!values.rating) {
      setLoading(true);
    }
    createRating.mutate(payload, {
      onSuccess: () => {
        if (!values.rating) {
          refetch();
          setRatingPage(false);
          message.success(
            "Terima kasih telah memberikan rating! Kami sangat menghargainya."
          );
        }
      },
      onError: () => {
        message.error(
          "Batas pengiriman rating telah habis. Silakan refresh halaman."
        );
        createRating.reset();
      },
      onSettled: () => {
        setLoading(false);
      },
    });
  };

  const debounceRating = useRef(
    debounce((value) => {
      submitHandler({
        rating_value: value,
        rating: true,
      });
    }, 10)
  );

  useEffect(() => {
    const currentDebouncedFn = debounceRating.current;
    return () => {
      if (currentDebouncedFn) {
        currentDebouncedFn.cancel();
      }
    };
  }, []);

  const onValuesChange = (value) => {
    if (value.rating_value) {
      debounceRating.current(value.rating_value);
    }
  };

  const initialValues = useMemo(() => {
    return {
      rating_value: data?.data ? data.data.rating_value : 5,
      message: data?.data ? data.data.message : "",
    };
  }, [data]);

  return (
    <>
      <Logo />
      <div className="text-center pt-2">
        <h3 className="font-bold text-lg">Terima kasih atas waktumu!</h3>
        <p className="tracking-wide">
          Kami ingin tahu bagaimana pengalamanmu dengan tim support kami
          barusan.
        </p>
      </div>
      <div className="mt-6">
        <h1 className="tracking-wide font-bold text-2xl text-center">
          Seberapa Puas Kamu Dengan Bantuan Yang Diberikan?
        </h1>
      </div>

      <Form
        form={form}
        initialValues={initialValues}
        onFinish={submitHandler}
        onValuesChange={onValuesChange}
        className="w-full"
      >
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.rating_value !== currentValues.rating_value
          }
        >
          {({ getFieldValue }) => {
            const rating = getFieldValue("rating_value") || 5;
            let iconName = "rating-5";

            if (rating <= 1) iconName = "rating-1";
            else if (rating <= 2) iconName = "rating-2";
            else if (rating <= 3) iconName = "rating-3";
            else if (rating <= 4) iconName = "rating-4";

            return (
              <div className="mt-8 text-center">
                <LazySvgIcon name={iconName} />
              </div>
            );
          }}
        </Form.Item>
        <div className="mt-5 flex justify-center">
          <Form.Item name="rating_value" noStyle>
            <Rate className="rating-user-rating text-4xl" allowClear={false} />
          </Form.Item>
        </div>
        <div className=" w-full mt-9">
          <p className="mb-1">Tulis komentar atau saranmu di bawah ini</p>
          <Form.Item name="message" noStyle>
            <TextArea
              rows={4}
              placeholder="Adminnya baik dan ramah ..."
              showCount
              maxLength={255}
            />
          </Form.Item>
        </div>
        <div className="w-full mt-4 ">
          <Button
            type="primary"
            className="mt-4 w-full"
            size="large"
            htmlType="submit"
            loading={loading || isLoading}
          >
            Kirim Rating
          </Button>
        </div>
      </Form>
    </>
  );
};

export default FormRating;
